import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-calender',
  templateUrl: './view-calender.component.html',
  styleUrls: ['/src/app/views/shared-style.scss']
})
export class ViewCalenderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
